import(/* webpackMode: "eager" */ "/builds/equipmentshare/fleet/fleet-ui/apps/fleet-configuration-dashboard/app/error.tsx");
